import PropertyService from '@/common/PropertyService';
import Firebase from '@/api/firebase/Firebase';

const appId = PropertyService.isPrd() ? 'e8b38ec1ad6c041d3ef1f2'
  : PropertyService.isAcc() ? '62251b852f6057903ef1f2'
    : '3342c05371cd67363ef1f2'

export default new Firebase({
  apiKey: import.meta.env.VITE_FIREBASE_API_KEY,
  authDomain: 'kso1-4c9e1.firebaseapp.com',
  projectId: 'kso1-4c9e1',
  storageBucket: 'kso1-4c9e1.firebasestorage.app',
  messagingSenderId: '995156490999',
  appId: `1:995156490999:web:${appId}`,
  vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY,
})
